<template>
  <div
    class="btn-create"
    :class="{'is-min': mini}">
    <router-link
      class="btn-create__btn"
      :class="{' px-4 ': !mini}"
      data-qa="btn-nav-bar"
      :disabled="disabled"
      :to="routerTo">
      <sIcon
        v-if="mini"
        type="plus"/>
      <span
        v-if="!mini"
        data-qa="btn-nav-bar-text">{{ label }}</span>
    </router-link>
    <sPopover
      v-if="!mini && hasValueSlot"
      ref="poper-menu"
      class="btn-create__menu"
      :disabled="disabled"
      placement="right-start"
      popper-class="menu"
      trigger="click"
      type="white">
      <div
        slot="reference">
        <sIcon
          color="var(--white-color)"
          type="menu"/>
      </div>
      <div class="btn-create__menu-items">
        <slot/>
      </div>
    </sPopover>
  </div>
</template>
<script>
export default {
  name: 'ButtonWithMenu',
  methods: {
    closeMenu() {
      this.$refs['poper-menu'].showPopper = false
    },
  },
  computed: {
    hasValueSlot() {
      return !!this.$slots.default
    },
  },
  props: {
    mini: {
      type: Boolean
    },
    routerTo: {
      type: Object
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-create {
  background: var(--black-color);
  border-radius: 50px;
  cursor: pointer;
  height: 40px;
  margin: 0 auto;
  width: fit-content;
  display: grid;
  grid-template-columns: minmax(50px, 1fr) 23px;
  color: var(--v-main__light_green-base) !important;
  &.is-min {
    width: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  &__btn {
    margin: auto 0;
    line-height: 22px;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    color: var(--v-main__light_green-base) !important;
    &:hover,
    &:focus {
      opacity: 0.5;
    }
  }
  &__menu {
    height: 100%;
    padding: 0 15px 0 0;
    line-height: 22px;
    font-size: 14px;
    display: flex;
    &::v-deep {
      &:hover .s-popover__reference-wrapper,
      &:focus .s-popover__reference-wrapper {
        opacity: 0.8;
      }
      .s-popover__reference-wrapper {
        margin: auto;
      }
    }
  }
}
</style>
